<template>
    <BaseModal :id="id" :static-backdrop="true" :keyboard="false">
        <template #header>
                    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" ref="closeChangePasswordBtn"></button>
        </template>
                    <Form class="p-3" @submit="onSubmit">
                        <Input
                            v-model="password"
                            name="password"
                            type="password"
                            :label="$t('user.password')"
                            :placeholder="$t('user.password-placeholder')"
                            :validations="['required', 'minLength(8)', 'maxLength(128)']"
                            :tip="passwordTip"
                            :tip-type="passwordTipType"
                        />
                        <Input
                            v-model="confirmPassword"
                            name="confirmPassword"
                            ref="confirmPassword"
                            type="password"
                            :label="$t('user.confirm-password')"
                            :placeholder="$t('user.confirm-password-placeholder')"
                            :validations="['required', 'minLength(8)', 'maxLength(128)']"
                            :tip="confirmPasswordTip"
                            :tip-type="confirmPasswordTipType"
                        />
                        <button type="submit" class="d-none" ref="submitBtn"></button>
                    </Form>
        <template #footer>
                    <button class="btn btn-primary" @click="submitForm">{{ $t('settings.profile.save') }}</button>
                    <button class="btn btn-outline-secondary ms-3" data-bs-dismiss="modal">{{ $t('cancel') }}</button>
        </template>
    </BaseModal>
</template>

<script>

import { Form } from 'vee-validate'
import Input from '../form/Input.vue'
import BaseModal from '../BaseModal.vue'

export default {
    name: 'changePasswordModal',
    data: () => ({
        id: 'changePasswordModal',
        password: '',
        confirmPassword: '',
        passwordTip: '',
        passwordTipType: 'regular',
        confirmPasswordTip: '',
        confirmPasswordTipType: 'regular'
    }),
    components: {
        Form,
        Input,
        BaseModal
    },
    watch: {
        confirmPassword(val) {
            if(this.password && val && val !== this.password) {
                this.confirmPasswordTip = 'Должны совпадать'
                this.confirmPasswordTipType = 'danger'
                this.$refs.confirmPassword.validateClass = 'danger'
            } else {
                this.confirmPasswordTip = ''
                this.confirmPasswordTipType = 'regular'
                this.$refs.confirmPassword.validateClass = 'regular'
            }
        }
    },
    methods: {
        submitForm() {
            this.$refs.submitBtn.click()
        },
        async onSubmit() {
            if(this.password !== this.confirmPassword) return

            let url = process.env.VUE_APP_API_URL + '/users/change-password'

            let body = {
                password: this.password
            }

            await axios.post(url, body, {
                withCredentials: true
            })
            .then((response) => {
                let r = response.data

                // return r.result === 'SUCCESS' ? true : false
                if(r.result === 'SUCCESS') {
                    this.$notify({
                        title: this.$t('notify.types.success'),
                        text: this.$t('settings.profile.notify.change-password-success'),
                        type: 'success'
                    })
    
                    this.$emit('changed')
                } else {
                    this.clear()

                    this.$notify({
                        title: this.$t('notify.types.error'),
                        text: this.$t('settings.profile.notify.change-password-error') + ' ' + r.message,
                        type: 'error'
                    })
                }
            })
        },
        clear() {
            this.password = ''
            this.confirmPassword = ''
            this.passwordTip = ''
            this.passwordTipType = 'regular'
            this.confirmPasswordTip = ''
            this.confirmPasswordTipType = 'regular'
        },
        close() {
            this.$refs.closeChangePasswordBtn.click()
        }
    }
}

</script>

<style scoped>

.modal-footer, .modal-header {
    border: none;
}

</style>
